"use strict";
var p5 = require('p5');
var p5sound = require('p5sound');
(function (SoundType) {
    SoundType[SoundType["MIDI_OSC"] = 0] = "MIDI_OSC";
})(exports.SoundType || (exports.SoundType = {}));
var SoundType = exports.SoundType;
;
var DEFAULT_MIDI_OSC_OPTIONS = {
    note: 0,
    attackLevel: 1.0,
    releaseLevel: 0,
    attackTime: 0.001,
    decayTime: 0.2,
    susPercent: 0.2,
    releaseTime: 0.5,
};
function playSound(sound) {
    switch (sound.type) {
        case SoundType.MIDI_OSC:
            var midiOptions = Object.assign({}, DEFAULT_MIDI_OSC_OPTIONS, sound.data);
            // console.debug('playSound[MIDI]:', sound, midiOptions);
            var env_1 = new p5.Env();
            env_1.setADSR(midiOptions.attackTime, midiOptions.decayTime, midiOptions.susPercent, midiOptions.releaseTime);
            env_1.setRange(midiOptions.attackLevel, midiOptions.releaseLevel);
            var osc_1 = new p5.SinOsc();
            // plug the oscillator into the gain
            osc_1.disconnect();
            sound.gain.setInput(osc_1);
            osc_1.start(sound.time);
            osc_1.freq(sound.p5.midiToFreq(midiOptions.note));
            env_1.play(osc_1, sound.time);
            setTimeout(function () {
                env_1.dispose();
                osc_1.dispose();
            }, sound.time + 10000); // TODO: Improve this timeout
            break;
        default:
            break;
    }
}
exports.playSound = playSound;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic291bmQtdHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzb3VuZC10eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsSUFBTSxFQUFFLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0FBQ3pCLElBQU0sT0FBTyxHQUFHLE9BQU8sQ0FBQyxTQUFTLENBQUMsQ0FBQztBQUluQyxXQUFZLFNBQVM7SUFDbkIsaURBQVEsQ0FBQTtBQUNWLENBQUMsRUFGVyxpQkFBUyxLQUFULGlCQUFTLFFBRXBCO0FBRkQsSUFBWSxTQUFTLEdBQVQsaUJBRVgsQ0FBQTtBQUFBLENBQUM7QUFvQkYsSUFBTSx3QkFBd0IsR0FBbUI7SUFDL0MsSUFBSSxFQUFFLENBQUM7SUFDUCxXQUFXLEVBQUUsR0FBRztJQUNoQixZQUFZLEVBQUUsQ0FBQztJQUNmLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFNBQVMsRUFBRSxHQUFHO0lBQ2QsVUFBVSxFQUFFLEdBQUc7SUFDZixXQUFXLEVBQUUsR0FBRztDQUNqQixDQUFDO0FBRUYsbUJBQTBCLEtBQW1CO0lBQzNDLE1BQU0sQ0FBQyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO1FBQ25CLEtBQUssU0FBUyxDQUFDLFFBQVE7WUFFckIsSUFBTSxXQUFXLEdBQ2YsTUFBTSxDQUFDLE1BQU0sQ0FBQyxFQUFFLEVBQUUsd0JBQXdCLEVBQUUsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDO1lBRTFELHlEQUF5RDtZQUV6RCxJQUFNLEtBQUcsR0FBRyxJQUFJLEVBQUUsQ0FBQyxHQUFHLEVBQUUsQ0FBQztZQUN6QixLQUFHLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FBQyxVQUFVLEVBQ3RCLFdBQVcsQ0FBQyxTQUFTLEVBQ3JCLFdBQVcsQ0FBQyxVQUFVLEVBQ3RCLFdBQVcsQ0FBQyxXQUFXLENBQUMsQ0FBQztZQUVyQyxLQUFHLENBQUMsUUFBUSxDQUFDLFdBQVcsQ0FBQyxXQUFXLEVBQUUsV0FBVyxDQUFDLFlBQVksQ0FBQyxDQUFDO1lBRWhFLElBQU0sS0FBRyxHQUFHLElBQUksRUFBRSxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBRTVCLG9DQUFvQztZQUNwQyxLQUFHLENBQUMsVUFBVSxFQUFFLENBQUM7WUFDakIsS0FBSyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsS0FBRyxDQUFDLENBQUM7WUFFekIsS0FBRyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDdEIsS0FBRyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLFVBQVUsQ0FBQyxXQUFXLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztZQUNoRCxLQUFHLENBQUMsSUFBSSxDQUFDLEtBQUcsRUFBRSxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDMUIsVUFBVSxDQUFDO2dCQUNULEtBQUcsQ0FBQyxPQUFPLEVBQUUsQ0FBQztnQkFDZCxLQUFHLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDaEIsQ0FBQyxFQUFFLEtBQUssQ0FBQyxJQUFJLEdBQUcsS0FBSyxDQUFDLENBQUMsQ0FBQyw2QkFBNkI7WUFDckQsS0FBSyxDQUFDO1FBRVI7WUFDRSxLQUFLLENBQUM7SUFDVixDQUFDO0FBQ0gsQ0FBQztBQW5DZSxpQkFBUyxZQW1DeEIsQ0FBQTtBQUFBLENBQUMifQ==


/*****************
 ** WEBPACK FOOTER
 ** ./src/services/sound/sound-types.ts
 ** module id = 970
 ** module chunks = 1
 **/